import { render, staticRenderFns } from "./addressDialog.vue?vue&type=template&id=044bc8a1&scoped=true"
import script from "./addressDialog.vue?vue&type=script&lang=js"
export * from "./addressDialog.vue?vue&type=script&lang=js"
import style0 from "./addressDialog.vue?vue&type=style&index=0&id=044bc8a1&prod&lang=scss&scoped=true"
import style1 from "./addressDialog.vue?vue&type=style&index=1&id=044bc8a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bc8a1",
  null
  
)

export default component.exports